// Generated by purs version 0.13.8
"use strict";
var insets = function (i) {
    return i;
};
module.exports = {
    insets: insets
};
